import { useState, useContext, useEffect } from "react";
import { Link, useParams} from "react-router-dom";
import { AdminContext } from "../../context/adminContext";
import Loader from "../../UI/Loader/Loader";
import CoveredBackground from "../../UI/СoveredBackground/СoveredBackground";
import ErrorMessage from "../../UI/ErrorMessage/ErrorMessage";

import ButtonBack from "../../UI/ButtonBack/ButtonBack";

 

const User = () => {
  const [user, setUser] = useState(null);
  const [laoding, setLaoding] = useState(null);
  const [error, setError] = useState(null);
 
  const { getUser, enableUser, disableUser } = useContext(AdminContext);
  const params = useParams();
 
  const  loadData = () => {
    setLaoding(true);
    getUser(params.id)
      .then((res) => {
        if (res.response) {
          if (res.response.data.message) {
            setError(res.response.data.message);
            return;
          }
        }
        document.title = 'Пользователь ' + res.data.u.surname + ' ' + res.data.u.name
        setUser(res.data);
        
      })
      .finally(() => {
        setLaoding(false);
      });
  }

  
  useEffect(() => {
    loadData()
    document.title = 'Пользователь'
  }, []);

  const enableHandler = (user_id) => {
    setUser(null)
    enableUser(user_id).finally(()=> { loadData()})
   
  }

  const disableHandler = (user_id) => {
    setUser(null)
    disableUser(user_id).finally(()=> { loadData()})
   
  }

  return (
    <div className="container">
      <div className="admin__user">
   
        <ButtonBack/>
        {laoding && (
          <div style={{ position: "relative", minHeight: 120 }}>
            <CoveredBackground>
              <Loader />
            </CoveredBackground>
          </div>
        )}

        {error && <ErrorMessage message={error} />}

        {user && (
          <>
            {(user.currentUser.admin == 2 || user.currentUser.admin == 1) &&
            user.currentUser.id != user.u.id &&
            user.u.admin == 2 ? (
              <>
                <div className="admin__user__name">
                  Доступ к данным пользователя{" "}
                  <span style={{ color: "red" }}>{user.u.name}</span> закрыт,
                  поскольку он является главным администратором
                </div>
              </>
            ) : user.currentUser.admin == 1 &&
              user.u.admin == user.currentUser.admin &&
              user.currentUser.id != user.u.id ? (
              <div className="admin__user__name">
                Доступ к данным пользователя
                <span style={{ color: "red" }}>{user.u.name}</span> закрыт
              </div>
            ) : (
              <>
                <Link
                  to={`/admin/users/${user.u.id}/edit`}
                  className="admin__results__link"
                >
                  Редактировать
                </Link>
                <div className="admin__user__name">ID: {user.u.id}</div>
                <div className="admin__user__name">Имя: {user.u.name}</div>
                <div className="admin__user__name">
                  Фамилия: {user.u.surname}
                </div>
                <div className="admin__user__name">ИИН: {user.u.iin}</div>

                {user.u.id != user.authUserId && (
                  <>
                    {user.u.active == 1 && (
                      <button
                        className="admin__results__link"
                        style={{
                          cursor: "pointer",
                          backgroundColor: "crimson",
                        }}
                        onClick={() => disableHandler(user.u.id)}
                      >
                        Отключить
                      </button>
                    )}

                    {user.u.active == 0 && (
                      <button
                        className="admin__results__link"
                        style={{ cursor: "pointer" }}

                        onClick={() => enableHandler(user.u.id)}
                      >
                        Включить 
                      </button>
                    )}
                  </>
                )}

                <div className="admin__user__results">
                  <div className="admin__user__title">
                    Результаты пройденных тестов
                  </div>
                  {user.results.length > 0 ? (
                    <div className="admin__user__items">
                      {user.results.map((res) => (
                        <div
                          className="admin__user__item"
                          key={`${res.id}${res.category_id}`}
                        >
                          <Link
                            to={`/admin/users/${user.u.id}/${res.category_id}/${res.id}`}
                            style={{ fontSize: 20 }}
                          >
                            Просмотреть.
                            {res.date}
                          </Link>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <>
                      <br />
                      <br />
                      <p style={{ fontSize: 32, color: "crimson" }}>
                        Здесь пока пусто
                      </p>
                    </>
                  )}
                </div>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default User;
